
export const getAPIURL = () => {
    var environment = process.env.NODE_ENV

    const apiUrl = 'https://api.campus.bluebottless.com/';

    return apiUrl;
}

export const getApiUrlForPayroll = () => {

    const apiUrlForPayroll = 'https://api.payroll-dev.suncolleges.ac.in/';

    return apiUrlForPayroll;
}


// getLicenseKey
export const getLicenseKey = 5566;